var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mode === 'DESIGN')?_c('div',[_vm._v(" "+_vm._s(_vm.placeholder)+" 根据公式计算 ")]):_c('div',[_vm._v(" "+_vm._s(_vm.placeholder)+" "+_vm._s(_vm._value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }